import { createContext } from 'react'

export const DEFAULT_TIMER_VALUE = Infinity
export const DEFAULT_EXPIRED_VALUE = false

export const CountdownTimerContext = createContext<number>(DEFAULT_TIMER_VALUE)
export const CountdownExpiredContext = createContext<boolean>(
  DEFAULT_EXPIRED_VALUE,
)
